import { VAULT_CLINICAL_URL } from "@myvp/shared/src/constants"
// oxlint-disable-next-line no-restricted-imports
import { createRoutePath } from "@myvp/shared/src/functions/create-route-path"

export const externalRouteNames = {
  econsentEditorHelp: `${VAULT_CLINICAL_URL}/12953/`,
  myVeevaHelp: "https://patients.myveeva.com/help/",
} as const

export const routeNames = {
  version: createRoutePath("/version"),
  error: createRoutePath("/error"),
  login: createRoutePath("/login"),
  confirmIdentity: createRoutePath("/login/confirm"),
  confirmIdentityEmail: createRoutePath("/login/confirm/email"),
  confirmIdentityPhone: createRoutePath("/login/confirm/phone"),
  identityConfirmed: createRoutePath("/confirm-email-mfa"),
  registerActivate: createRoutePath("/register/activate"),
  resetAccount: createRoutePath("/register/reset"),
  registerActivateRedirect: createRoutePath("/register/activate/redirect"),
  registerConfirmYob: createRoutePath("/register/confirm-year-of-birth"),
  registerSetUsername: createRoutePath("/register/set-username"),
  registerSetPassword: createRoutePath("/register/set-password"),
  registerSetVerificationMethod: createRoutePath(
    "/register/set-verification-method"
  ),
  registerSetVerificationMethodEmail: createRoutePath(
    "/register/set-verification-method/email"
  ),
  registerSetVerificationMethodPhone: createRoutePath(
    "/register/set-verification-method/phone"
  ),
  registerConfirmEmail: createRoutePath("/register/confirm/email"),
  registerConfirmPhone: createRoutePath("/register/confirm/phone"),
  registerLegacyConfirmIdentity: createRoutePath("/register-email/confirm"),
  registerLegacyConfirmPhone: createRoutePath("/register-email/confirm/phone"),
  registerLegacySetPassword: createRoutePath("/register-email/set-password"),
  registerLegacySetUsername: createRoutePath("/register-email/set-username"),
  enterMfa: createRoutePath("/welcome"),
  resetSvUserPassword: createRoutePath("/user/reset"),
  forgotPassword: createRoutePath("/forgot-password"),
  forgotPasswordEmailSent: createRoutePath("/forgot-password/email"),
  newPassword: createRoutePath("/new-password"),
  newPasswordMfa: createRoutePath("/new-password/mfa"),
  setNewPassword: createRoutePath("/new-password/set"),
  econsentPdfEditor: createRoutePath("/econsent/pdf/editor/:documentId"),
  econsentPdfPreview: createRoutePath("/econsent/pdf/preview/:previewCode"),
  econsentPdfEditorPreview: createRoutePath(
    "/econsent/pdf/editor-preview/:previewCode"
  ),
  econsentPdfViewer: createRoutePath("/econsent/pdf/viewer/:documentId"),
  econsentEditor: createRoutePath("/econsent/editor"),
  determineUser: createRoutePath("/determine-user"),
  confirmNewNumber: createRoutePath("/confirm-new-number"),
  confirmNewNumberMfa: createRoutePath("/confirm-new-number/mfa"),
  confirmNewEmail: createRoutePath("/confirm-new-email"),
  confirmNewEmailExpired: createRoutePath("/confirm-new-email/expired"),
  econsentPreviewDocumentRoot: createRoutePath("/econsent/preview"),
  econsentPreviewDocument: createRoutePath("/econsent/preview/:documentId"),
  econsentPreviewDocumentFromEditorRoot: createRoutePath(
    "/econsent/editor/preview"
  ),
  econsentPreviewDocumentFromEditor: createRoutePath(
    "/econsent/editor/preview/:documentId"
  ),
  /** @deprecated */
  econsentViewDocumentFromTasks: createRoutePath(
    "/tasks/econsent/view/:documentId"
  ),
  econsentViewDocumentFromStudy: createRoutePath(
    "/study/consent-forms/view/:documentId"
  ),
  econsentViewDocumentFromTodo: createRoutePath(
    "/todo/econsent/view/:documentId"
  ),
  /** @deprecated */
  econsentViewDocumentFromDocuments: createRoutePath(
    "/documents/econsent/view/:documentId"
  ),
  econsentPreviewGenerator: createRoutePath(
    "/econsent/preview/create/:documentId"
  ),
  econsentGenerate: createRoutePath("/econsent/generate"),
  termsOfService: createRoutePath("/terms"),
  privacyNotice: createRoutePath("/privacy"),
  help: createRoutePath("/help"),
  inPerson: createRoutePath("/inperson"),
  inPersonConfirm: createRoutePath("/inperson/confirm"),
  inPersonEconsentViewer: createRoutePath(
    "/inperson/econsent/view/:documentId"
  ),
  inPersonEconsentPdfViewer: createRoutePath(
    "/inperson/econsent/pdf/view/:documentId"
  ),
  inPersonRoles: createRoutePath("/inperson/roles"),
  inPersonSuccess: createRoutePath("/inperson/success"),
  entry: createRoutePath("/"),
  /** @deprecated */
  tasks: createRoutePath("/tasks"),
  /** @deprecated */
  documents: createRoutePath("/documents"),
  /** @deprecated */
  visits: createRoutePath("/visits"),
  /** @deprecated */
  studies: createRoutePath("/studies"),
  account: createRoutePath("/account"),
  activateNewStudy: createRoutePath("/account/activate"),
  activateNewStudyConfirmYob: createRoutePath(
    "/account/activate/confirm-year-of-birth"
  ),
  settings: createRoutePath("/settings"),
  todo: createRoutePath("/todo"),
  completed: createRoutePath("/todo/completed"),
  patientsRedirect: createRoutePath("/patients-redirect"),
  /** @deprecated */
  viewVisitFromVisits: createRoutePath("/visits/view/:visitId"),
  viewVisitFromTodos: createRoutePath("/todo/visit/view/:visitId"),
  viewDiaryDetails: createRoutePath("/todo/epro/diary/:diaryId"),
  viewDiarySurvey: createRoutePath("/todo/epro/diary/:diaryId/view/:surveyId"),
  viewDiaryDetailsFromCompleted: createRoutePath(
    "/todo/completed/diary/:diaryId"
  ),
  viewDiarySurveyFromCompleted: createRoutePath(
    "/todo/completed/view/:surveyId"
  ),
  viewDiarySurveyFromDetailsCompleted: createRoutePath(
    "/todo/completed/diary/:diaryId/view/:surveyId"
  ),
  eproScreenshot: createRoutePath("/epro/:collectionId/screenshot/:surveyId"),
  diaryDetailsScreenshot: createRoutePath(
    "/epro/:collectionId/screenshot/diary/:surveyId"
  ),
  eproLibrarySurveyTemplateScreenshot: createRoutePath(
    "/epro/screenshot/surveyTemplate/:surveyTemplateId/languageTag/:languageTag"
  ),
  libraryDiaryDetailsScreenshot: createRoutePath(
    "/epro/screenshot/surveyTemplate/:surveyTemplateId/diary/languageTag/:languageTag"
  ),
  /** @deprecated */
  eproViewSurveyFromTasks: createRoutePath("/tasks/epro/view/:surveyId"),
  eproViewSurveyFromTodo: createRoutePath("/todo/epro/view/:surveyId"),
  eproViewTrainingSurvey: createRoutePath("/todo/epro/view/training/:surveyId"),
  eproViewPreviewTrainingSurvey: createRoutePath(
    "/preview/epro/training/:collectionId/:surveyId/:surveyLocale"
  ),
  studyDetailsScreenshot: createRoutePath(
    "/epro/:collectionId/screenshot/study-details"
  ),
  studyTabScreenshot: createRoutePath("/epro/:collectionId/screenshot/study"),
  studyDescriptionScreenshot: createRoutePath(
    "/epro/:collectionId/screenshot/study-description"
  ),
  resourcesScreenshot: createRoutePath(
    "/epro/:sponsorStudyId/screenshot/resources"
  ),
  redirectToAppstore: createRoutePath("/redirect-to-appstore"),
  /**
   * @deprecated
   * NOTE you can find an associate route for this in sponsors/epro-module.route-names.ts
   */
  DEPRECATED_eproPreviewV2: createRoutePath(
    `/sponsor/studio/preview/:surveyId`
  ),
  /**
   * @deprecated
   * NOTE you can find an associate route for this in sponsors/epro-module.route-names.ts
   */
  DEPRECATED_eproPreviewV1: createRoutePath(`/sponsor/epro/preview/:surveyId`),
  /** @deprecated */
  DEPRECATED_econsentViewDocument: createRoutePath(
    "/econsent/view/studies/:taskId/documents/:documentId"
  ),
  /** @deprecated */
  DEPRECATED_econsentStudies: createRoutePath("/econsent/view/studies"),
  /** @deprecated */
  DEPRECATED_econsentLibrary: createRoutePath("/econsent/view/library"),
  /** @deprecated */
  DEPRECATED_econsentViewDocumentFromLibrary: createRoutePath(
    "/econsent/view/library/documents/:documentId"
  ),
} as const

export const globalRouteNames = {
  privacyNotice: routeNames.privacyNotice,
  termsOfService: routeNames.termsOfService,
  help: routeNames.help,
} as const
